/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerCardCollateral} from '../api'

export const useMutationRegisterCardCollateral = createReactQueryMutationHook('registerCardCollateral', registerCardCollateral)
